import { Card } from '../../../components/ui/Card';

/**
 * A StatTile-shaped placeholder: same card, same height, a pulsing label and
 * value. Shown while a tile's numbers load, so the row holds its shape instead
 * of reading "—" (which looks like "no data") and then jumping.
 */
export function TileSkeleton({ label }: { label?: string }) {
  return (
    <Card padding="md">
      <div aria-busy="true" aria-live="polite">
        {label ? (
          <p className="eyebrow truncate">{label}</p>
        ) : (
          <div className="h-3 w-24 animate-pulse rounded-sm bg-surface-tertiary" />
        )}
        <div className="mt-3 h-8 w-32 animate-pulse rounded-sm bg-surface-tertiary" />
        <div className="mt-2 h-3 w-40 animate-pulse rounded-sm bg-surface-tertiary" />
        <span className="sr-only">Loading…</span>
      </div>
    </Card>
  );
}
